import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import type { LotCarbonEmissions } from 'api'

import { TooltipContainer, TooltipText } from './components'

type DailyMethaneEmission =
  LotCarbonEmissions['lot']['carbonEmissions']['dailyMethaneEmissions'][number]

interface CarbonEmissionsTooltipPayload {
  payload?: DailyMethaneEmission
}

interface Props {
  active?: boolean
  payload?: CarbonEmissionsTooltipPayload[]
}

export const CarbonEmissionsTooltip: React.FC<Props> = ({ active, payload }) => {
  const { t } = useTranslation('lot-dashboard')
  const { t: commonT } = useTranslation('common')
  const emission = payload?.[0]?.payload

  if (!active || !emission) return null

  const value = commonT('systemsFormat.localizeNumber', {
    val: emission.methaneCo2eKg,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return (
    <TooltipContainer>
      <TooltipText>{`${commonT('vocabulary.daysAfterEmergenceAbbreviation')}: ${
        emission.daysSinceEmergence
      }`}</TooltipText>
      <TooltipText>
        {t('carbonEmissionsCard.chart.tooltipDate', { date: dayjs(emission.date) })}
      </TooltipText>
      <TooltipText>
        {t('carbonEmissionsCard.chart.tooltipEmission', {
          value,
          unit: commonT('systems.carbonDioxideEquivalentKilograms'),
        })}
      </TooltipText>
    </TooltipContainer>
  )
}
